import { inject, Injectable } from '@angular/core';
import { ContactInfo } from '../contact-info.const';
import { ContactType, MenuItem, MenuItemType } from '../models';
import { formatPhoneNumber } from '../util.functions';
import { AppRoutePath } from '../route-translation';
import { CountryInfoService } from './country-info.service';

@Injectable({ providedIn: 'root' })
export class MenuService {
	private readonly countryInfoService = inject(CountryInfoService);
	private items: MenuItem[] = [
		{
			type: MenuItemType.Home,
			label: `menu.navigation.home`,
			route: [AppRoutePath.Home],
			root: true,
			visible: true,
		},
		{
			type: MenuItemType.Destination,
			label: `menu.navigation.destinations`,
			iconRight: 'pi pi-angle-down',
			route: null,
			root: true,
			visible: true,
			items: [
				[
					{
						items: this.countryInfoService.countryList.slice(0, 4).map((country) => ({
							key: country.key,
							label: country.name,
							route: country.route,
							image: country.image,
						})),
					},
				],
				[
					{
						items: this.countryInfoService.countryList.slice(4, 8).map((country) => ({
							key: country.key,
							label: country.name,
							route: country.route,
							image: country.image,
						})),
					},
				],
			],
		},
		{
			type: MenuItemType.LastMinute,
			label: `menu.navigation.lastMinute`,
			iconRight: 'pi pi-angle-down',
			route: [AppRoutePath.LastMinute],
			root: true,
			visible: true,
		},
		{
			type: MenuItemType.FirstMinute,
			label: `menu.navigation.firstMinute`,
			iconRight: 'pi pi-angle-down',
			route: [AppRoutePath.FirstMinute],
			root: true,
			visible: true,
		},
		{
			type: MenuItemType.Premium,
			label: `menu.navigation.premium`,
			iconRight: 'pi pi-angle-down',
			route: [AppRoutePath.Premium],
			root: true,
			visible: true,
		},
		{
			type: MenuItemType.SpecialOffer,
			label: `menu.navigation.specialOffer`,
			iconRight: 'pi pi-angle-down',
			route: [AppRoutePath.SpecialOffer],
			root: true,
			visible: true,
		},
		{
			type: MenuItemType.Contact,
			label: `menu.navigation.contact`,
			iconRight: 'pi pi-angle-down',
			route: null,
			root: true,
			visible: true,
			items: [
				[
					{
						items: ContactInfo.contactList
							.filter((contact) => contact.type === ContactType.Phone)
							.map((contact) => ({
								label: contact.label,
								subtext: formatPhoneNumber(contact.value),
								nativeLink: contact.link,
								image: `icons/${contact.customIcon}.svg`,
								sideSubtext: true,
							})),
					},
				],
				[
					{
						items: ContactInfo.contactList
							.filter((contact) => contact.type !== ContactType.Phone)
							.map((contact) => ({
								label: contact.label,
								subtext: ContactType.Email ? contact.value : formatPhoneNumber(contact.value),
								nativeLink: contact.link,
								image: `icons/${contact.customIcon}.svg`,
								sideSubtext: true,
							})),
					},
				],
			],
		},
		{
			type: MenuItemType.AboutUs,
			label: 'menu.navigation.aboutUs',
			route: [AppRoutePath.AboutUs],
			root: true,
			visible: true,
		},
	];

	public getMenuItems(): MenuItem[] {
		return this.items;
	}
}
